import * as React from 'react';
import { FC } from 'react';

interface DynamicSnakeProps {
  svgId: string;
  pathId: string;
}

const DynamicSnake: FC<DynamicSnakeProps> = ({ svgId, pathId }) => {
  return (
    <svg id={svgId} width="353" height="1410" viewBox="0 0 353 1410" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        id={pathId}
        d="M194 0V368C194 384 163 441 116 441C40 441 24 506 24 521C24 536 29.5 608 107 608C179.5 608
             194 672 194 698C194 724 164.5 777.5 107 777.5C62 777.5 24 816.5 24 865C24 913.5 68.5 944.5
              107 944.5C145.5 944.5 193.5 972.5 193.5 1027.5C193.5 1082.5 154 1113 107 1113C60 1113 24
               1151 24 1195C24 1239 56.5 1283 112.5 1283C160.5 1283 214.667 1283 225 1283C274.5 1283
                329 1284.6 329 1349V1410"
        stroke="#ff56f6"
        strokeWidth="36"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6435_35932"
          x1="83.8813"
          y1="-0.00145034"
          x2="422.709"
          y2="76.6633"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF56F6" />
          <stop offset="0.348958" stopColor="#B936EE" />
          <stop offset="0.702463" stopColor="#3BACE2" />
          <stop offset="1" stopColor="#406AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DynamicSnake;
